<template>
  <v-form @submit.prevent="save">
    <v-container>
      <v-layout wrap>
        <v-flex xs12 md6>
          <v-dialog
              ref="dialog"
              v-model="modal"
              :return-value.sync="electricityBill.date"
              persistent
              lazy
              full-width
              width="290px"
          >
            <v-text-field
                v-validate="'required'"
                slot="activator"
                v-model="computedDate"
                :label="$t('Pages.ElectricityBills.model.date')"
                readonly
                color="error"
                :error-messages="errors.first('date')"
                name="date"
            ></v-text-field>
            <v-date-picker locale="sr-Latn-RS" color="error" v-model="electricityBill.date" scrollable>
              <v-spacer></v-spacer>
              <v-btn flat @click="modal = false">{{$t('Core.Fields.cancel')}}</v-btn>
              <v-btn flat color="error" @click="$refs.dialog.save(electricityBill.date)">{{$t('Core.Fields.ok')}}</v-btn>
            </v-date-picker>
          </v-dialog>
        </v-flex>
        <v-flex xs12 md6>
          <v-text-field
              v-validate="'required'"
              v-model="electricityBill.local_currency_course"
              :error-messages="errors.first('local_currency_course')"
              :label="$t('Pages.ElectricityBills.model.local_currency_course')"
              min="0"
              type="number"
              color="indigo"
              name="local_currency_course"
              step="0.01"
          />
        </v-flex>
      </v-layout>
      <v-layout wrap>
        <!--  AEVT  -->
        <v-flex xs12 md4>
          <v-text-field
              v-validate="'required'"
              v-model="electricityBill.aevt_old"
              :error-messages="errors.first('aevt_old')"
              :label="$t('Pages.ElectricityBills.model.aevt_old')"
              min="0"
              type="number"
              color="indigo"
              name="aevt_old"
              step="0.001"
          />
        </v-flex>
        <v-flex xs12 md4>
          <v-text-field
              v-validate="'required|min_value:' + electricityBill.aevt_old"
              v-model="electricityBill.aevt"
              :error-messages="errors.first('aevt')"
              :label="$t('Pages.ElectricityBills.model.aevt')"
              min="0"
              type="number"
              color="indigo"
              name="aevt"
              step="0.001"
          />
        </v-flex>
        <v-flex xs12 md4>
          <v-text-field
              v-validate="'required'"
              v-model="electricityBill.aevt_price"
              :error-messages="errors.first('aevt_price')"
              :label="$t('Pages.ElectricityBills.model.aevt_price')"
              min="0"
              type="number"
              color="indigo"
              name="aevt_price"
              step="0.001"
          />
        </v-flex>
        <!--  AEVT  -->

        <!--  AENT  -->
        <v-flex xs12 md4>
          <v-text-field
              v-validate="'required'"
              v-model="electricityBill.aent_old"
              :error-messages="errors.first('aent_old')"
              :label="$t('Pages.ElectricityBills.model.aent_old')"
              min="0"
              type="number"
              color="indigo"
              name="aent_old"
              step="0.001"
          />
        </v-flex>
        <v-flex xs12 md4>
          <v-text-field
              v-validate="'required|min_value:' + electricityBill.aent_old"
              v-model="electricityBill.aent"
              :error-messages="errors.first('aent')"
              :label="$t('Pages.ElectricityBills.model.aent')"
              min="0"
              type="number"
              color="indigo"
              name="aent"
              step="0.001"
          />
        </v-flex>
        <v-flex xs12 md4>
          <v-text-field
              v-validate="'required'"
              v-model="electricityBill.aent_price"
              :error-messages="errors.first('aent_price')"
              :label="$t('Pages.ElectricityBills.model.aent_price')"
              min="0"
              type="number"
              color="indigo"
              name="aent_price"
              step="0.001"
          />
        </v-flex>
        <!--  AENT  -->
        <!--  REVT / RENT  -->
        <v-flex xs12 md6>
          <v-text-field
              v-validate="'required'"
              v-model="electricityBill.revt_old"
              :error-messages="errors.first('revt_old')"
              :label="$t('Pages.ElectricityBills.model.revt_old')"
              min="0"
              type="number"
              color="indigo"
              name="revt_old"
              step="0.001"
          />
        </v-flex>
        <v-flex xs12 md6>
          <v-text-field
              v-validate="'required|min_value:' +  electricityBill.revt_old"
              v-model="electricityBill.revt"
              :error-messages="errors.first('revt')"
              :label="$t('Pages.ElectricityBills.model.revt')"
              min="0"
              type="number"
              color="indigo"
              name="revt"
              step="0.001"
          />
        </v-flex>
        <v-flex xs12 md6>
          <v-text-field
              v-validate="'required'"
              v-model="electricityBill.rent_old"
              :error-messages="errors.first('rent_old')"
              :label="$t('Pages.ElectricityBills.model.rent_old')"
              min="0"
              type="number"
              color="indigo"
              name="rent_old"
              step="0.001"
          />
        </v-flex>
        <v-flex xs12 md6>
          <v-text-field
              v-validate="'required|min_value:' + electricityBill.rent_old"
              v-model="electricityBill.rent"
              :error-messages="errors.first('rent')"
              :label="$t('Pages.ElectricityBills.model.rent')"
              min="0"
              type="number"
              color="indigo"
              name="rent"
              step="0.001"
          />
        </v-flex>
        <!--  REVT / RENT  -->
        <!--  MAX GRAPHS  -->
        <v-flex xs12 md6>
          <v-text-field
              v-validate="'required'"
              v-model="electricityBill.max_graph1"
              :error-messages="errors.first('max_graph1')"
              :label="$t('Pages.ElectricityBills.model.max_graph1')"
              min="0"
              type="number"
              color="indigo"
              name="max_graph1"
          />
        </v-flex>
        <v-flex xs12 md6>
          <v-text-field
              v-validate="'required'"
              v-model="electricityBill.max_graph2"
              :error-messages="errors.first('max_graph2')"
              :label="$t('Pages.ElectricityBills.model.max_graph2')"
              min="0"
              type="number"
              color="indigo"
              name="max_graph2"
          />
        </v-flex>
        <!--  MAX GRAPHS  -->
        <!--  RE 0.95  -->
        <v-flex xs12 md6>
          <v-text-field
              readonly
              v-validate="'required'"
              v-model="electricityBill.re_095"
              :error-messages="errors.first('re_095')"
              :label="$t('Pages.ElectricityBills.model.re_095')"
              min="0"
              type="number"
              color="indigo"
              name="re_095"
              step="0.001"
          />
        </v-flex>
        <v-flex xs12 md6>
          <v-text-field
              readonly
              v-validate="'required'"
              v-model="electricityBill.exceeded_re_095"
              :error-messages="errors.first('exceeded_re_095')"
              :label="$t('Pages.ElectricityBills.model.exceeded_re_095')"
              min="0"
              type="number"
              color="indigo"
              name="exceeded_re_095"
              step="0.001"
          />
        </v-flex>
        <!--  RE 0.95  -->

        <!--  CONSTANTS  -->
        <h3 class="text-indigo">{{ $t('Pages.ElectricityConstants.title')}}</h3>
        <v-layout row wrap>
          <v-flex xs12 md4>
            <v-text-field
                v-validate="'required'"
                v-model="electricityBill.re_095_constant"
                :error-messages="errors.first('re_095_constant')"
                :label="$t('Pages.ElectricityBills.model.re_095_constant')"
                min="0"
                type="number"
                color="indigo"
                name="re_095_constant"
                step="0.000000001"
            />
          </v-flex>
          <v-flex xs12 md4>
            <v-text-field
                v-validate="'required'"
                v-model="electricityBill.calculation_constant"
                :error-messages="errors.first('calculation_constant')"
                :label="$t('Pages.ElectricityBills.model.calculation_constant')"
                min="0"
                type="number"
                color="indigo"
                name="calculation_constant"
            />
          </v-flex>
          <v-flex xs12 md4>
            <v-text-field
                v-validate="'required'"
                v-model="electricityBill.approved_current_strength"
                :error-messages="errors.first('approved_current_strength')"
                :label="$t('Pages.ElectricityBills.model.approved_current_strength')"
                min="0"
                type="number"
                color="indigo"
                name="approved_current_strength"
            />
          </v-flex>
          <v-flex xs12 md4>
            <v-text-field
                v-validate="'required'"
                v-model="electricityBill.energy_improvement_fee"
                :error-messages="errors.first('energy_improvement_fee')"
                :label="$t('Pages.ElectricityBills.model.energy_improvement_fee')"
                min="0"
                type="number"
                color="indigo"
                name="energy_improvement_fee"
                step="0.001"
            />
          </v-flex>
          <v-flex xs12 md4>
            <v-text-field
                v-validate="'required'"
                v-model="electricityBill.approved_current_price"
                :error-messages="errors.first('approved_current_price')"
                :label="$t('Pages.ElectricityBills.model.approved_current_price')"
                min="0"
                type="number"
                color="indigo"
                name="approved_current_price"
                step="0.001"
            />
          </v-flex>
          <v-flex xs12 md4>
            <v-text-field
                v-validate="'required'"
                v-model="electricityBill.exceeded_current_price"
                :error-messages="errors.first('exceeded_current_price')"
                :label="$t('Pages.ElectricityBills.model.exceeded_current_price')"
                min="0"
                type="number"
                color="indigo"
                name="exceeded_current_price"
                step="0.001"
            />
          </v-flex>
          <v-flex xs12 md4>
            <v-text-field
                v-validate="'required'"
                v-model="electricityBill.re_price"
                :error-messages="errors.first('re_price')"
                :label="$t('Pages.ElectricityBills.model.re_price')"
                min="0"
                type="number"
                color="indigo"
                name="re_price"
                step="0.001"
            />
          </v-flex>
          <v-flex xs12 md4>
            <v-text-field
                v-validate="'required'"
                v-model="electricityBill.exceeded_re_price"
                :error-messages="errors.first('exceeded_re_price')"
                :label="$t('Pages.ElectricityBills.model.exceeded_re_price')"
                min="0"
                type="number"
                color="indigo"
                name="exceeded_re_price"
                step="0.001"
            />
          </v-flex>
          <v-flex xs12 md4>
            <v-text-field
                v-validate="'required'"
                v-model="electricityBill.re_095_price"
                :error-messages="errors.first('re_095_price')"
                :label="$t('Pages.ElectricityBills.model.re_095_price')"
                min="0"
                type="number"
                color="indigo"
                name="re_095_price"
                step="0.001"
            />
          </v-flex>
          <v-flex xs12 md4>
            <v-text-field
                v-validate="'required'"
                v-model="electricityBill.aent_access_price"
                :error-messages="errors.first('aent_access_price')"
                :label="$t('Pages.ElectricityBills.model.aent_access_price')"
                min="0"
                type="number"
                color="indigo"
                name="aent_access_price"
                step="0.001"
            />
          </v-flex>
          <v-flex xs12 md4>
            <v-text-field
                v-validate="'required'"
                v-model="electricityBill.incentives_for_supplier"
                :error-messages="errors.first('incentives_for_supplier')"
                :label="$t('Pages.ElectricityBills.model.incentives_for_supplier')"
                min="0"
                type="number"
                color="indigo"
                name="incentives_for_supplier"
                step="0.001"
            />
          </v-flex>
          <v-flex xs12 md4>
            <v-text-field
                v-validate="'required'"
                v-model="electricityBill.aevt_access_price"
                :error-messages="errors.first('aevt_access_price')"
                :label="$t('Pages.ElectricityBills.model.aevt_access_price')"
                min="0"
                type="number"
                color="indigo"
                name="aevt_access_price"
                step="0.001"
            />
          </v-flex>
        </v-layout>
        <!--  CONSTANTS  -->
      </v-layout>
      <v-layout row wrap>
        <v-btn round color="indigo" dark type="submit">
          {{$t('Core.Fields.save')}}
        </v-btn>
        <v-btn round href="javascript:history.go(-1)">
          {{$t('Core.Fields.back')}}
        </v-btn>
      </v-layout>
    </v-container>
  </v-form>
</template>

<script>
import store from "../../store";

export default {
  components: {},
  props: {
      electricityBill: {
          type: Object,
          required: true
      },
      edit: {
          type: Boolean,
          default: false
      }
  },
  computed: {
    computedDate(val) {
      return this.getLocaleDateFormat(this.electricityBill.date);
    },
  },
  data: () => ({
    modal: false
  }),
  methods: {
      save(){
        this.$validator.validateAll().then((result) => {
            if (result) {
              let data = JSON.parse(JSON.stringify(this.electricityBill));
              this.$emit('save', data);
            }
        });
      },
      calculateReactiveEnergy() {
        let aevtOld = this.electricityBill.aevt_old ? Number(this.electricityBill.aevt_old) : 0;
        let aentOld = this.electricityBill.aent_old ? Number(this.electricityBill.aent_old) : 0;
        let revtOld = this.electricityBill.revt_old ? Number(this.electricityBill.revt_old) : 0;
        let rentOld = this.electricityBill.rent_old ? Number(this.electricityBill.rent_old) : 0;
        let aevt = this.electricityBill.aevt ? Number(this.electricityBill.aevt) : 0;
        let aent = this.electricityBill.aent ? Number(this.electricityBill.aent) : 0;
        let revt = this.electricityBill.revt ? Number(this.electricityBill.revt) : 0;
        let rent = this.electricityBill.rent ? Number(this.electricityBill.rent) : 0;
        let calculation_constant = this.electricityBill.calculation_constant ? Number(this.electricityBill.calculation_constant) : 0;
        let re_095_constant = this.electricityBill.re_095_constant ? Number(this.electricityBill.re_095_constant) : 0;

        let aevtDiff = aevt - aevtOld;
        let aentDiff = aent - aentOld;
        let revtDiff = revt - revtOld;
        let rentDiff = rent - rentOld;
        this.electricityBill.re_095 = Math.round((aevtDiff + aentDiff) * calculation_constant * re_095_constant);
        this.electricityBill.exceeded_re_095 = (revtDiff + rentDiff) * calculation_constant - this.electricityBill.re_095;
        this.electricityBill.exceeded_re_095 = this.electricityBill.exceeded_re_095 > 0 ? Math.round(this.electricityBill.exceeded_re_095) : 0;
      }
  },
  watch: {
    'electricityBill.aevt_old': function () {
      this.calculateReactiveEnergy();
    },
    'electricityBill.aent_old': function () {
      this.calculateReactiveEnergy();
    },
    'electricityBill.revt_old': function () {
      this.calculateReactiveEnergy();
    },
    'electricityBill.rent_old': function () {
      this.calculateReactiveEnergy();
    },
    'electricityBill.aevt': function () {
      this.calculateReactiveEnergy();
    },
    'electricityBill.aent': function () {
      this.calculateReactiveEnergy();
    },
    'electricityBill.revt': function () {
      this.calculateReactiveEnergy();
    },
    'electricityBill.rent': function () {
      this.calculateReactiveEnergy();
    },
    'electricityBill.re_095_constant': function () {
      this.calculateReactiveEnergy();
    },
    'electricityBill.calculation_constant': function () {
      this.calculateReactiveEnergy();
    }
  }
}
</script>

<style lang="scss">

</style>
